import { render, staticRenderFns } from "./EditorAssignmentsTableControls.vue?vue&type=template&id=7edbea2f&scoped=true&"
import script from "./EditorAssignmentsTableControls.vue?vue&type=script&lang=js&"
export * from "./EditorAssignmentsTableControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edbea2f",
  null
  
)

export default component.exports